import { render, staticRenderFns } from "./WorkshopConfig.vue?vue&type=template&id=25df77ec&scoped=true&"
import script from "./WorkshopConfig.vue?vue&type=script&lang=js&"
export * from "./WorkshopConfig.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopConfig.vue?vue&type=style&index=0&id=25df77ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df77ec",
  null
  
)

export default component.exports